import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceTemplate } from 'src/modules/invoice/models/invoiceTemplate';
import { ControlledAutocompleteDropdown } from 'src/shared/components/form/controlledAutocompleteDropdown';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { InvoiceTemplateStatusEnum } from 'src/shared/models/enums/invoiceTemplateStatus.enum';
import { InvoiceTemplateOptions } from 'src/shared/models/options/invoiceTemplateOptions';
import { getAllInvoiceTemplate } from 'src/shared/services/invoiceService';

type MemberCreateInvoiceTemplateProps = {
  ownerId: number | undefined;
  callback: (templateId: number | undefined) => void;
};

export const MemberCreateInvoiceTemplate = (props: MemberCreateInvoiceTemplateProps) => {
  const { ownerId, callback } = props;
  const { t } = useTranslation(['invoice']);
  const [, setLoading] = useState<boolean>(true);

  const isMounted = useIsMounted();

  const [invoiceTemplates, setInvoiceTemplates] = useState<InvoiceTemplate[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const opts = new InvoiceTemplateOptions();
        opts.owner_id = ownerId;
        opts.status = InvoiceTemplateStatusEnum.Visible;

        const res = await getAllInvoiceTemplate(opts);
        if (isMounted()) {
          setInvoiceTemplates(res.data.results);
        }
      } catch (e) {
        if (isMounted()) {
          ConsoleHelper.log(e);
        }
      } finally {
        if (isMounted()) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [isMounted, ownerId]);

  return (
    <ControlledAutocompleteDropdown<InvoiceTemplate>
      options={invoiceTemplates}
      label={t('invoice:createInvoice.invoiceTemplate')}
      name='invoiceTemplateId'
      nameProp='name'
      callback={(x) => {
        callback(x?.template_id);
      }}
    />
  );
};
